import { render } from "./Intro.vue?vue&type=template&id=35fb4190&scoped=true&ts=true"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"

import "./Intro.vue?vue&type=style&index=0&id=35fb4190&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fb4190"]])

export default __exports__